import { IMeetingFormData, IMeetingFormPayload } from './types';

const meteengFormDataParcer = (
  payload: IMeetingFormPayload,
): IMeetingFormData => ({
  kid_id: payload.kid_id,
  id: payload.id,
  text: payload!.text || '',
  file: payload.files.name ? payload.files : null,
});

export default meteengFormDataParcer;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/modal/dataparser.ts